<template>
  <Button
    type="text"
    class="vc-voice-play-btn"
    :class="{ 'vc-voice-play-btn--playing': playing }"
    :loading="loading"
    :title="resolvedTitle"
    v-on="$listeners"
  >
    <Icon
      v-if="!loading"
      :type="playing ? 'ios-pause' : 'ios-play'"
      :size="iconSize"
    />
  </Button>
</template>

<script>
export default {
  name: 'VoicePlayIconButton',
  props: {
    playing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    iconSize: {
      type: [Number, String],
      default: 20,
    },
  },
  computed: {
    resolvedTitle() {
      if (this.title) return this.title
      return this.playing ? '停止试听' : '试听'
    },
  },
}
</script>

<style scoped>
.vc-voice-play-btn {
  flex-shrink: 0;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 50% !important;
  background: #d7e5ff !important;
  color: #2d8cf0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: background-color 0.2s ease;
  box-shadow: none !important;
}

.vc-voice-play-btn:hover,
.vc-voice-play-btn:focus,
.vc-voice-play-btn.ivu-btn:hover,
.vc-voice-play-btn.ivu-btn:focus {
  background: #bdd6ff !important;
  color: #1677ff !important;
  border: none !important;
  box-shadow: none !important;
}

.vc-voice-play-btn ::v-deep .ivu-icon {
  vertical-align: -0.225em;
  margin-left: 3px;
  line-height: 1;
}

.vc-voice-play-btn--playing {
  background: #2d8cf0 !important;
  color: #fff !important;
}

.vc-voice-play-btn--playing:hover,
.vc-voice-play-btn--playing:focus,
.vc-voice-play-btn--playing.ivu-btn:hover,
.vc-voice-play-btn--playing.ivu-btn:focus {
  background: #1677ff !important;
  color: #fff !important;
}

.vc-voice-play-btn--playing ::v-deep .ivu-icon {
  margin-left: 1px;
}
</style>
